import { GetBusinessLabel } from "Utilities/utils";

export function getTemplateNotification(obj) {
    const title = GetBusinessLabel("ReportNotificationTemplate1");
    const message = GetBusinessLabel("ReportNotificationTemplate2")
        .replace("|placeholder|", `${obj?.FirstName || ""} ${obj?.LastName || ""}`)
        .replace(/<br\s*\/?>/gi, "\r\n"); 
    return `${title}\r\n\r\n${message}`;
}